if (!customElements.get('product-media-stack')) {
  customElements.define(
    'product-media-stack',
    class ProductMediaStack extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.product__media-stack');
        // Desktop thumbnail rail and mobile dot indicators both jump-scroll
        // to a photo on click and track the active photo the same way.
        this.indicators = Array.from(
          this.querySelectorAll('.product__thumbnail-rail-item, .product__dot')
        );
        this.items = Array.from(this.querySelectorAll('.product__media-stack-item'));

        if (!this.scroller || this.indicators.length === 0) return;

        this.indicators.forEach((button) => {
          button.addEventListener('click', () => {
            const target = this.querySelector(`#${button.dataset.target}`);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });

        if (this.items.length === 0 || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            const mostVisible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (!mostVisible) return;
            const activeId = mostVisible.target.id;
            this.indicators.forEach((button) => {
              button.classList.toggle('is-active', button.dataset.target === activeId);
            });
          },
          { root: this.scroller, threshold: [0.5] }
        );
        this.items.forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
